import CloseIcon from '@mui/icons-material/Close'
import FacebookIcon from '@mui/icons-material/Facebook'
import LinkedInIcon from '@mui/icons-material/LinkedIn'
import {
  Box,
  Grid,
  Link,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'

import logoFooter from '@assets/images/logo-footer.png'
import BoxStyled, { GridStyled } from './FooterHome.style'

const FooterHome = () => {
  const { t } = useTranslation()
  const theme = useTheme()
  const isSmallDevice = useMediaQuery(theme.breakpoints.down('sm'))
  return (
    <BoxStyled>
      <Grid container spacing={isSmallDevice ? 6 : 10}>
        {/* Left Section */}
        <GridStyled item xs={12} md={3} width={'30%'}>
          <Typography variant='h5' sx={{ fontWeight: 'bold' }}>
            <img
              src={logoFooter}
              alt='logo invoicia'
              width='auto'
              style={{ objectFit: 'contain' }}
            />
          </Typography>
          <Typography variant='body2' sx={{ mt: 2 }}>
            {t('home.footer_description')}
          </Typography>
          <Stack direction='row' spacing={2} sx={{ mt: 2 }}>
            <LinkedInIcon sx={{ cursor: 'pointer' }} />
            <CloseIcon sx={{ cursor: 'pointer' }} />
            <FacebookIcon sx={{ cursor: 'pointer' }} />
          </Stack>
        </GridStyled>

        <Grid item sm={6} md={2}>
          <Typography fontWeight='bold' gutterBottom>
            {t('home.footer_information')}
          </Typography>
          <Link href='#' underline='none' sx={{ color: '#D1D5DB' }}>
            {t('home.footer_certification')}
          </Link>
          <br />
          <Link href='#' underline='none' sx={{ color: '#D1D5DB' }}>
            {t('home.footer_how_it_works')}
          </Link>
          <br />
          <Link href='#' underline='none' sx={{ color: '#D1D5DB' }}>
            {t('home.footer_cost')}
          </Link>
        </Grid>

        <Grid item sm={6} md={2}>
          <Typography fontWeight='bold' gutterBottom>
            {t('home.footer_support')}
          </Typography>
          <Link href='#' underline='none' sx={{ color: '#D1D5DB' }}>
            {t('home.footer_help')}
          </Link>
          <br />
          <Link href='#' underline='none' sx={{ color: '#D1D5DB' }}>
            {t('home.footer_contact')}
          </Link>
          <br />
          <Link href='#' underline='none' sx={{ color: '#D1D5DB' }}>
            {t('home.footer_blog')}
          </Link>
        </Grid>

        <Grid item sm={6} md={2}>
          <Typography fontWeight='bold' gutterBottom>
            {t('home.footer_legal')}
          </Typography>
          <Link href='#' underline='none' sx={{ color: '#D1D5DB' }}>
            {t('home.footer_terms')}
          </Link>
          <br />
          <Link href='#' underline='none' sx={{ color: '#D1D5DB' }}>
            {t('home.footer_privacy')}
          </Link>
          <br />
          <Link href='#' underline='none' sx={{ color: '#D1D5DB' }}>
            {t('home.footer_legal_notice')}
          </Link>
        </Grid>

        <Grid item sm={6} md={3}>
          <Typography fontWeight='bold' gutterBottom>
            {t('home.footer_resources')}
          </Typography>
          <Link href='#' underline='none' sx={{ color: '#D1D5DB' }}>
            {t('home.footer_e_invoice')}
          </Link>
          <br />
          <Link href='#' underline='none' sx={{ color: '#D1D5DB' }}>
            {t('home.footer_billing_software')}
          </Link>
          <br />
          <Link href='#' underline='none' sx={{ color: '#D1D5DB' }}>
            {t('home.footer_make_invoice')}
          </Link>
        </Grid>
      </Grid>

      {/* Bottom Bar */}
      <Box
        sx={{
          margin: '6rem 0 0 0',
          borderTop: '1px solid rgba(255,255,255,0.2)',
          pt: 2,
        }}
      >
        <Typography variant='body2' align='center'>
          © 2024 Codeur.com
        </Typography>
      </Box>
    </BoxStyled>
  )
}

export default FooterHome
